<!-- 作业反馈 -->
<template>
	<div>
		<div class="index">
			<div class="header">
				<div class="left" @click="goBack()">&lt;返回</div>
				<div class="span1">
					<span>张三老师本周作业备案详情</span>
				</div>
				<div class="right"></div>
			</div>

			<div>
				<el-form :inline="true" :model="queryParams" label-width="45px">
					<el-form-item label="学科:">
						<el-select v-model="queryParams.subjectId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in SubjectList"
								:key="item.subjectId"
								:label="item.subjectName"
								:value="item.subjectId"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="教师:">
						<el-select
							v-model="queryParams.teacherId"
							clearable
							filterable
							placeholder="请选择"
							class="label"
						>
							<el-option
								v-for="item in SubjectList"
								:key="item.teacherId"
								:label="item.teacherName"
								:value="item.teacherId"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-button type="primary" size="small" @click="searchFun()" class="findBtn"
						>查询</el-button
					>
				</el-form>

				<!-- 校内教师 -->
				<div class="table">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="username" label="班级" align="center"> </el-table-column>
						<el-table-column prop="homeworkDate" label="作业日期" align="center"> </el-table-column>
						<el-table-column prop="subjectName" label="作业内容" align="center"> </el-table-column>
						<el-table-column prop="classname" label="预计完成时长" align="center">
						</el-table-column>
						<el-table-column prop="finishDuration" label="被驳回次数" align="center">
						</el-table-column>
						<el-table-column prop="finishDuration1" label="登记时间" align="center">
						</el-table-column>
						<el-table-column prop="" label="操作" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click="toDetail(scope)">查看详情</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<div class="pagination">
						<el-pagination
							background
							:current-page="pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							:total="totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getHwFeedbackList } from "@/api/school/index.js";
	import to from "@/utils/await-to";
	import dayjs from "dayjs";
	import reqTip from "@/utils/requestTip";
	import localForage from "localforage";

	export default {
		components: {},
		data() {
			return {
				tableData: [],
				classList: [],
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				queryParams: {
					classId: "",
					subjectId: "",
					homeworkDate: "",
					difficulty: "",
					feedbackDate: "",
				},
			};
		},
		watch: {},
		activated() {
			this.getTableData();
		},
		created() {
			this.getCommonList();
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			async getCommonList() {
				this.classList = await localForage.getItem("classList");
			},
			// 获取作业反馈列表
			async getTableData() {
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					// usessionid: "a236a5446a0d11ec9eb4d68a870965b9",
					usessionid: ss.usessionid,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					classId: this.queryParams.classId,
					homeworkDate:
						(this.queryParams.homeworkDate &&
							dayjs(this.queryParams.homeworkDate).format("YYYY-MM-DD")) ||
						"",
					subjectId: this.queryParams.subjectId,
					difficulty: this.queryParams.difficulty,
					feedbackDate:
						(this.queryParams.feedbackDate &&
							dayjs(this.queryParams.feedbackDate).format("YYYY-MM-DD")) ||
						"",
				};
				const [err, res] = await to(getHwFeedbackList(params));
				console.log("作业反馈列表--", res);
				if (err || res.result != "000000") {
					err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取作业反馈列表失败");
					console.log("err-->", err || res);
					return;
				}
				let list = res.data.list;
				list.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.feedbackDate = dayjs(item.feedbackDate).format("YYYY-MM-DD HH:mm");
					item.estimateDuration = item.estimateDuration + "分钟";
					item.finishDuration = item.finishDuration + "分钟";
				});
				this.tableData = list;
				this.totalPage = res.data.total;
			},
			// 查看详情
			toDetail(item) {
				item.jobType = this.jobType;
				if (item.status == 0) item.showCheckArea = true;
				console.log("详情item--", { ...item });
				this.$router.push({
					path: "/task/record/detail",
					// query: { id: item.homeworkId, jobType: this.jobType, showCheckArea: true },
					query: item,
				});
			},
			//新增后刷新作业反馈列表
			refreshTableData() {
				this.getTableData();
			},

			searchFun() {
				this.pageNum = 1;
				this.getTableData();
			},
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.getTableData();
			},
			currentChangeHandle(val) {
				this.pageNum = val;
				this.getTableData();
			},
		},
	};
</script>
<style lang="less" scoped>
	.index {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 60px;
			line-height: 48px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #eee;
			align-items: center;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				font-size: 14px;
				color: #8b8b8b;
				cursor: pointer;
			}
		}
		.findBtn {
			float: right;
			width: 80px;
			height: 32px;
			border-radius: 3px;
			background: #4991e1;
			font-size: 14px;
			margin-top: 5px;
		}
		.hwContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			> div:first-child img {
				width: 18px;
				height: 18px;
				margin-top: 6px;
				margin-right: 5px;
			}
			> div:last-child {
				text-align: left;
			}
		}
		.show-hover {
			cursor: pointer;
		}

		::v-deep .el-form-item__label {
			color: #333;
		}
		::v-deep .el-form .el-input__inner {
			width: 120px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}
		::v-deep .el-table {
			color: #333;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-table thead th.el-table__cell {
			padding: 15 0.5px 0;
			font-weight: normal;
			font-size: 14px;
			color: #7a8da2;
			background: #fafafa;
		}
		::v-deep .el-table tbody td.el-table__cell {
			padding: 18.5px 0;
		}

		.pagination {
			text-align: center;
			margin-top: 30px;
		}
		.waitPreview {
			color: #4b83f7;
		}
		.inPreview {
			color: orange;
		}
		.passed {
			color: #50b173;
		}
		.rejected {
			color: #f74b4b;
		}
		.classFrame {
			::v-deep .el-input__inner {
				width: 135px;
			}
		}
		::v-deep .el-date-editor.el-input {
			width: 150px;
		}
		::v-deep .el-date-editor .el-input__inner {
			width: 150px !important;
		}
		::v-deep .el-icon-arrow-left {
			margin-top: 0;
		}
		::v-deep .el-icon-arrow-right {
			margin-top: 0;
		}
	}
</style>
